<template>
  <v-form ref="articleEditForm" v-model="valid">
    <div class="back-btn" @click="$router.push({name: 'article-index'})">
      <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M36 27H23.83L29.42 21.41L28 20L20 28L28 36L29.41 34.59L23.83 29H36V27Z" fill="#8C959D"/>
      </svg>
    </div>
    <v-row>
      <v-col cols="12">
        <h1>{{this.id ? 'Редактирование статьи' : 'Создание статьи'}}</h1>
      </v-col>
      <v-col cols="12">
      <div class="">
        <v-img :src="previewImage(true, image)" width="655" height="190">
          <template v-slot:placeholder>
            <div class="image-placeholder"></div>
          </template>
        </v-img>
      </div>
      </v-col>
      <v-col  cols="12" sm="8" md="6" xl="5">
        <v-file-input label="Картинка"
                      prepend-icon=""
                      class="cursor-pointer"
                      outlined
                      placeholder="3840х1220.jpg"
                      append-icon="mdi-attachment"
                      v-model="image">
        </v-file-input>
        <v-tabs v-model="tabLang">
          <v-tab>RU</v-tab>
          <v-tab>UA</v-tab>
        </v-tabs>
        <v-tabs-items v-model="tabLang">
          <v-tab-item :eager="true">
            <v-row>
              <v-col>
                <v-text-field
                        v-model="article.name"
                        label="Заголовок"
                        :rules="[rules.required]"
                        required
                        outlined
                ></v-text-field>
                <editor api-key="8z95zxrw4xtjnn7a2unyi14ym91kzk8j6549luv0ow3cmn2i" v-model="article.description" :init="{
                  convert_urls: false,
                  height: 700,
                  relative_urls: false,
                  file_picker_types: 'image media',
                  images_file_types: 'jpeg,jpg,png,gif,svg',
                  images_upload_handler: images_upload_handler,
                }" :toolbar="toolbar" :plugins="plugins"/>
                <v-text-field
                    class="mt-5"
                    v-model="article.seo_title"
                    label="SEO Title"
                    :rules="[rules.required]"
                    required
                    outlined
                ></v-text-field>
                <v-text-field
                    v-model="article.seo_description"
                    label="SEO Description"
                    :rules="[rules.required]"
                    required
                    outlined
                ></v-text-field>
              </v-col>
            </v-row>
          </v-tab-item>
          <v-tab-item :eager="true">
            <v-row>
              <v-col>
                <v-text-field
                    v-model="article.name_ua"
                    label="Заголовок"
                    :rules="[rules.required]"
                    required
                    outlined
                ></v-text-field>
                <editor api-key="8z95zxrw4xtjnn7a2unyi14ym91kzk8j6549luv0ow3cmn2i" v-model="article.description_ua" :init="init" :toolbar="toolbar" :plugins="plugins"/>
                <v-text-field
                    class="mt-5"
                    v-model="article.seo_title_ua"
                    label="SEO Title"
                    :rules="[rules.required]"
                    required
                    outlined
                ></v-text-field>
                <v-text-field
                    v-model="article.seo_description_ua"
                    label="SEO Description"
                    :rules="[rules.required]"
                    required
                    outlined
                ></v-text-field>
              </v-col>
            </v-row>
          </v-tab-item>
        </v-tabs-items>
        <v-text-field
                v-model="article.slug"
                label="Ссылка"
                outlined
        ></v-text-field>
        <v-btn v-if="id" @click="update">Сохранить</v-btn>
        <v-btn v-else @click="create">Создать</v-btn>
      </v-col>
      <v-snackbar
              v-model="snackbar"
              :timeout="timeout"
              :color="snackbarColor"
              right
              top
      >
        {{ snackbarText }}
      </v-snackbar>
    </v-row>
  </v-form>
</template>

<script>
  // @ is an alias to /src
  import Editor from '@tinymce/tinymce-vue'
  import ArticleService from "@/api/ArticleService";

  export default {
    name: 'NewsEdit',
    props: {
        id: {
            default: null,
        }
    },
    components: {Editor},
    data: () => ({

      plugins: 'advlist autolink lists link image charmap print preview anchor searchreplace visualblocks code fullscreen insertdatetime media table paste code help wordcount',
      toolbar: 'undo redo | formatselect | bold italic backcolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | removeformat | code ',
      snackbar: false,
      timeout: 2000,
      snackbarText: '',
      snackbarColor: '',
      rules: {
        required: value => !!value || 'Нужно заполнить',
        requiredSelect: [(v) => !!v.id || 'Нужно заполнить'],
      },
      valid: true,
      tab: '',
      tabLang: '',
      article: {
        name_ua: '',
        description: '',
        description_ua: '',
        seo_description: '',
        seo_description_ua: '',
        seo_title: '',
        seo_title_ua: '',
        slug: '',
      },
      image: null,
      loading: true,
      loadingButton: false,
    }),
    mounted() {
        if(this.id) {
            ArticleService.get(this.id)
                .then(response => {
                    this.article = response.data;

                    if (this.article.image) {
                        this.image = this.article.image;
                        this.image.name = this.article.image.file
                    }
                    this.loading = false
                });
        }
    },
    methods: {
      images_upload_handler(blobInfo, success, failure, folderName) {
        const xhr = new XMLHttpRequest()
        xhr.withCredentials = false

        xhr.open('POST', 'https://vilki-palki.od.ua/api/image/upload')
        xhr.setRequestHeader(
            'Authorization',
            this.getCookie('auth._token.local')
        )

        xhr.onload = function () {
          if (xhr.status !== 200) {
            failure('HTTP Error: ' + xhr.status)
            return
          }
          const json = JSON.parse(xhr.responseText)

          if (!json || typeof json.url !== 'string') {
            failure('Invalid JSON: ' + xhr.responseText)
            return
          }
          success(json.url)
        }

        const formData = new FormData()
        formData.append('file', blobInfo.blob(), blobInfo.filename())

        xhr.send(formData)
      },
      getCookie(name) {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) return parts.pop().split(';').shift();
      },
      validate() {
        this.$refs.articleEditForm.validate()
        if(this.article.name == '' && this.article.name_ua != ''){
          this.tabLang = 0;
        }
        if(this.article.name != '' && this.article.name_ua == ''){
          this.tabLang = 1;
        }

        if (this.article.description == '' && this.article.description_ua != '') {
          this.tabLang = 0;
        }
        if (this.article.description != '' && this.article.description_ua == '') {
          this.tabLang = 1;
        }

      },
      previewImage(isList, image) {
        if(this.image && this.image.url){
            return this.image.url
        }
        if(image){
          return URL.createObjectURL(image)
        }
      },
      update(){
        this.validate()
        if(!this.valid){
          return false
        }

        this.loadingButton = true;
        let formData = this.getData();

        ArticleService.update(formData).then(response => {
          this.snackbar = true;
          this.snackbarText = 'Новость успешно обновлена';
          this.snackbarColor = 'success';
        }).catch(error => {
          this.snackbar = true;
          this.snackbarText = 'Ошибка при обновлении новости';
          this.snackbarColor = 'error';
        }).finally(() => {
          this.loadingButton = false
        })
      },
      create(){
        this.validate()
        if(!this.valid){
          return false
        }
        this.loadingButton = true;
        var formData = this.getData();

        ArticleService.create(formData).then(response => {
            this.$router.push({ name: 'article-edit', params: { id: response.data.id } })
          this.article.id = response.id
          this.snackbar = true;
          this.snackbarText = 'Новость создан';
          this.snackbarColor = 'success';
        }).catch(error => {
          this.snackbar = true;
          this.snackbarText = 'Ошибка при создании новости';
          this.snackbarColor = 'error';
        }).finally(() => {
          this.loadingButton = false
        })
      },
      getData() {
          let formData = new FormData();

          formData.append('id', this.id);
          formData.append('name', this.article.name);
          formData.append('name_ua', this.article.name_ua);
          formData.append('description', this.article.description);
          formData.append('description_ua', this.article.description_ua);
          formData.append('seo_description', this.article.seo_description);
          formData.append('seo_description_ua', this.article.seo_description_ua);
          formData.append('seo_title', this.article.seo_title);
          formData.append('seo_title_ua', this.article.seo_title_ua);
          formData.append('slug', this.article.slug);
          if(this.image && !this.image.url) {
              formData.append('image', this.image);
          }

          return formData;
      }
    },
  }
</script>

<style scoped lang="scss">
  .image-placeholder{
    width: 100%;
    height: 100%;
    background-color: #F3F7FC;
    border-radius: 4px;
  }
  .article-images .v-image{
    max-height: 374px;
  }
  .mobile{
    width: 300px;
    height: 300px;
    margin-bottom: 24px;
  }
  .article{
    position: relative;
    &:before{
      content: "";
      padding-top: 100%;
      display: block;
    }

    .content{
      position: absolute;
      width: 100%;
      left: 0;
      top: 0;
      height: 100%;
      background-color: #F8FBFF;
      border-right-style: 3px;
      .img{
        height: 3.541vw;
        margin-top: .83vw;
      }
      .name{
        margin-top: .72vw;
        text-align: center;
        color: #8C959D;
      }
    }
  }
</style>
